// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: trading-calendar.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Exchange, exchangeFromJSON, exchangeToJSON } from "./common";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.tradingcalendar";

export enum EventType {
  EVENT_TYPE_UNKNOWN = 0,
  TRADING_HOLIDAY = 1,
  CLEARING_HOLIDAY = 2,
  SPECIAL_TRADING_DAY = 3,
  UNRECOGNIZED = -1,
}

export function eventTypeFromJSON(object: any): EventType {
  switch (object) {
    case 0:
    case "EVENT_TYPE_UNKNOWN":
      return EventType.EVENT_TYPE_UNKNOWN;
    case 1:
    case "TRADING_HOLIDAY":
      return EventType.TRADING_HOLIDAY;
    case 2:
    case "CLEARING_HOLIDAY":
      return EventType.CLEARING_HOLIDAY;
    case 3:
    case "SPECIAL_TRADING_DAY":
      return EventType.SPECIAL_TRADING_DAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EventType.UNRECOGNIZED;
  }
}

export function eventTypeToJSON(object: EventType): string {
  switch (object) {
    case EventType.EVENT_TYPE_UNKNOWN:
      return "EVENT_TYPE_UNKNOWN";
    case EventType.TRADING_HOLIDAY:
      return "TRADING_HOLIDAY";
    case EventType.CLEARING_HOLIDAY:
      return "CLEARING_HOLIDAY";
    case EventType.SPECIAL_TRADING_DAY:
      return "SPECIAL_TRADING_DAY";
    case EventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TradingSessionType {
  TRADING_SESSION_TYPE_UNKNOWN = 0,
  MORNING_SESSION = 1,
  MUHURAT_SESSION = 2,
  MOCK_SESSION = 3,
  UNRECOGNIZED = -1,
}

export function tradingSessionTypeFromJSON(object: any): TradingSessionType {
  switch (object) {
    case 0:
    case "TRADING_SESSION_TYPE_UNKNOWN":
      return TradingSessionType.TRADING_SESSION_TYPE_UNKNOWN;
    case 1:
    case "MORNING_SESSION":
      return TradingSessionType.MORNING_SESSION;
    case 2:
    case "MUHURAT_SESSION":
      return TradingSessionType.MUHURAT_SESSION;
    case 3:
    case "MOCK_SESSION":
      return TradingSessionType.MOCK_SESSION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TradingSessionType.UNRECOGNIZED;
  }
}

export function tradingSessionTypeToJSON(object: TradingSessionType): string {
  switch (object) {
    case TradingSessionType.TRADING_SESSION_TYPE_UNKNOWN:
      return "TRADING_SESSION_TYPE_UNKNOWN";
    case TradingSessionType.MORNING_SESSION:
      return "MORNING_SESSION";
    case TradingSessionType.MUHURAT_SESSION:
      return "MUHURAT_SESSION";
    case TradingSessionType.MOCK_SESSION:
      return "MOCK_SESSION";
    case TradingSessionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TradingCalendarEvent {
  exchange: Exchange;
  name: string;
  eventType: EventType;
  date: string;
}

export interface TradingCalendarEvents {
  tradingCalendarEvents: TradingCalendarEvent[];
}

export interface TradingSession {
  type: string;
  name: string;
  startTime: number;
  endTime: number;
  preOpenStartTime: number;
  preOpenEndTime: number;
  postCloseStartTime: number;
  postCloseEndTime: number;
}

export interface TradingCalendars {
  tradingCalendersData: TradingCalendarData[];
}

export interface TradingCalendarData {
  exchange: Exchange;
  holidays: TradingCalendarEvent[];
  specialTradingDays: SpecialTradingDay[];
  tradingSessions: TradingSession[];
}

export interface SpecialTradingDay {
  date: string;
  sessionTypes: string[];
}

export interface ExchangeTradingSession {
  exchange: Exchange;
  tradingSessions: TradingSession[];
}

function createBaseTradingCalendarEvent(): TradingCalendarEvent {
  return { exchange: 0, name: "", eventType: 0, date: "" };
}

export const TradingCalendarEvent = {
  encode(message: TradingCalendarEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.eventType !== 0) {
      writer.uint32(24).int32(message.eventType);
    }
    if (message.date !== "") {
      writer.uint32(34).string(message.date);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingCalendarEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingCalendarEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.eventType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.date = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingCalendarEvent {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      eventType: isSet(object.eventType) ? eventTypeFromJSON(object.eventType) : 0,
      date: isSet(object.date) ? globalThis.String(object.date) : "",
    };
  },

  toJSON(message: TradingCalendarEvent): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.eventType !== 0) {
      obj.eventType = eventTypeToJSON(message.eventType);
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingCalendarEvent>, I>>(base?: I): TradingCalendarEvent {
    return TradingCalendarEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingCalendarEvent>, I>>(object: I): TradingCalendarEvent {
    const message = createBaseTradingCalendarEvent();
    message.exchange = object.exchange ?? 0;
    message.name = object.name ?? "";
    message.eventType = object.eventType ?? 0;
    message.date = object.date ?? "";
    return message;
  },
};

function createBaseTradingCalendarEvents(): TradingCalendarEvents {
  return { tradingCalendarEvents: [] };
}

export const TradingCalendarEvents = {
  encode(message: TradingCalendarEvents, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tradingCalendarEvents) {
      TradingCalendarEvent.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingCalendarEvents {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingCalendarEvents();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingCalendarEvents.push(TradingCalendarEvent.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingCalendarEvents {
    return {
      tradingCalendarEvents: globalThis.Array.isArray(object?.tradingCalendarEvents)
        ? object.tradingCalendarEvents.map((e: any) => TradingCalendarEvent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingCalendarEvents): unknown {
    const obj: any = {};
    if (message.tradingCalendarEvents?.length) {
      obj.tradingCalendarEvents = message.tradingCalendarEvents.map((e) => TradingCalendarEvent.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingCalendarEvents>, I>>(base?: I): TradingCalendarEvents {
    return TradingCalendarEvents.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingCalendarEvents>, I>>(object: I): TradingCalendarEvents {
    const message = createBaseTradingCalendarEvents();
    message.tradingCalendarEvents = object.tradingCalendarEvents?.map((e) => TradingCalendarEvent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTradingSession(): TradingSession {
  return {
    type: "",
    name: "",
    startTime: 0,
    endTime: 0,
    preOpenStartTime: 0,
    preOpenEndTime: 0,
    postCloseStartTime: 0,
    postCloseEndTime: 0,
  };
}

export const TradingSession = {
  encode(message: TradingSession, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.startTime !== 0) {
      writer.uint32(48).int64(message.startTime);
    }
    if (message.endTime !== 0) {
      writer.uint32(56).int64(message.endTime);
    }
    if (message.preOpenStartTime !== 0) {
      writer.uint32(64).int64(message.preOpenStartTime);
    }
    if (message.preOpenEndTime !== 0) {
      writer.uint32(80).int64(message.preOpenEndTime);
    }
    if (message.postCloseStartTime !== 0) {
      writer.uint32(96).int64(message.postCloseStartTime);
    }
    if (message.postCloseEndTime !== 0) {
      writer.uint32(112).int64(message.postCloseEndTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingSession {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.startTime = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.endTime = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.preOpenStartTime = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.preOpenEndTime = longToNumber(reader.int64() as Long);
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.postCloseStartTime = longToNumber(reader.int64() as Long);
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.postCloseEndTime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingSession {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      startTime: isSet(object.startTime) ? globalThis.Number(object.startTime) : 0,
      endTime: isSet(object.endTime) ? globalThis.Number(object.endTime) : 0,
      preOpenStartTime: isSet(object.preOpenStartTime) ? globalThis.Number(object.preOpenStartTime) : 0,
      preOpenEndTime: isSet(object.preOpenEndTime) ? globalThis.Number(object.preOpenEndTime) : 0,
      postCloseStartTime: isSet(object.postCloseStartTime) ? globalThis.Number(object.postCloseStartTime) : 0,
      postCloseEndTime: isSet(object.postCloseEndTime) ? globalThis.Number(object.postCloseEndTime) : 0,
    };
  },

  toJSON(message: TradingSession): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.startTime !== 0) {
      obj.startTime = Math.round(message.startTime);
    }
    if (message.endTime !== 0) {
      obj.endTime = Math.round(message.endTime);
    }
    if (message.preOpenStartTime !== 0) {
      obj.preOpenStartTime = Math.round(message.preOpenStartTime);
    }
    if (message.preOpenEndTime !== 0) {
      obj.preOpenEndTime = Math.round(message.preOpenEndTime);
    }
    if (message.postCloseStartTime !== 0) {
      obj.postCloseStartTime = Math.round(message.postCloseStartTime);
    }
    if (message.postCloseEndTime !== 0) {
      obj.postCloseEndTime = Math.round(message.postCloseEndTime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingSession>, I>>(base?: I): TradingSession {
    return TradingSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingSession>, I>>(object: I): TradingSession {
    const message = createBaseTradingSession();
    message.type = object.type ?? "";
    message.name = object.name ?? "";
    message.startTime = object.startTime ?? 0;
    message.endTime = object.endTime ?? 0;
    message.preOpenStartTime = object.preOpenStartTime ?? 0;
    message.preOpenEndTime = object.preOpenEndTime ?? 0;
    message.postCloseStartTime = object.postCloseStartTime ?? 0;
    message.postCloseEndTime = object.postCloseEndTime ?? 0;
    return message;
  },
};

function createBaseTradingCalendars(): TradingCalendars {
  return { tradingCalendersData: [] };
}

export const TradingCalendars = {
  encode(message: TradingCalendars, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tradingCalendersData) {
      TradingCalendarData.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingCalendars {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingCalendars();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingCalendersData.push(TradingCalendarData.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingCalendars {
    return {
      tradingCalendersData: globalThis.Array.isArray(object?.tradingCalendersData)
        ? object.tradingCalendersData.map((e: any) => TradingCalendarData.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingCalendars): unknown {
    const obj: any = {};
    if (message.tradingCalendersData?.length) {
      obj.tradingCalendersData = message.tradingCalendersData.map((e) => TradingCalendarData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingCalendars>, I>>(base?: I): TradingCalendars {
    return TradingCalendars.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingCalendars>, I>>(object: I): TradingCalendars {
    const message = createBaseTradingCalendars();
    message.tradingCalendersData = object.tradingCalendersData?.map((e) => TradingCalendarData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTradingCalendarData(): TradingCalendarData {
  return { exchange: 0, holidays: [], specialTradingDays: [], tradingSessions: [] };
}

export const TradingCalendarData = {
  encode(message: TradingCalendarData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    for (const v of message.holidays) {
      TradingCalendarEvent.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.specialTradingDays) {
      SpecialTradingDay.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.tradingSessions) {
      TradingSession.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingCalendarData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingCalendarData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.holidays.push(TradingCalendarEvent.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.specialTradingDays.push(SpecialTradingDay.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.tradingSessions.push(TradingSession.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingCalendarData {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      holidays: globalThis.Array.isArray(object?.holidays)
        ? object.holidays.map((e: any) => TradingCalendarEvent.fromJSON(e))
        : [],
      specialTradingDays: globalThis.Array.isArray(object?.specialTradingDays)
        ? object.specialTradingDays.map((e: any) => SpecialTradingDay.fromJSON(e))
        : [],
      tradingSessions: globalThis.Array.isArray(object?.tradingSessions)
        ? object.tradingSessions.map((e: any) => TradingSession.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingCalendarData): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.holidays?.length) {
      obj.holidays = message.holidays.map((e) => TradingCalendarEvent.toJSON(e));
    }
    if (message.specialTradingDays?.length) {
      obj.specialTradingDays = message.specialTradingDays.map((e) => SpecialTradingDay.toJSON(e));
    }
    if (message.tradingSessions?.length) {
      obj.tradingSessions = message.tradingSessions.map((e) => TradingSession.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingCalendarData>, I>>(base?: I): TradingCalendarData {
    return TradingCalendarData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingCalendarData>, I>>(object: I): TradingCalendarData {
    const message = createBaseTradingCalendarData();
    message.exchange = object.exchange ?? 0;
    message.holidays = object.holidays?.map((e) => TradingCalendarEvent.fromPartial(e)) || [];
    message.specialTradingDays = object.specialTradingDays?.map((e) => SpecialTradingDay.fromPartial(e)) || [];
    message.tradingSessions = object.tradingSessions?.map((e) => TradingSession.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpecialTradingDay(): SpecialTradingDay {
  return { date: "", sessionTypes: [] };
}

export const SpecialTradingDay = {
  encode(message: SpecialTradingDay, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    for (const v of message.sessionTypes) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpecialTradingDay {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpecialTradingDay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.sessionTypes.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpecialTradingDay {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      sessionTypes: globalThis.Array.isArray(object?.sessionTypes)
        ? object.sessionTypes.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SpecialTradingDay): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.sessionTypes?.length) {
      obj.sessionTypes = message.sessionTypes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpecialTradingDay>, I>>(base?: I): SpecialTradingDay {
    return SpecialTradingDay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpecialTradingDay>, I>>(object: I): SpecialTradingDay {
    const message = createBaseSpecialTradingDay();
    message.date = object.date ?? "";
    message.sessionTypes = object.sessionTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseExchangeTradingSession(): ExchangeTradingSession {
  return { exchange: 0, tradingSessions: [] };
}

export const ExchangeTradingSession = {
  encode(message: ExchangeTradingSession, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    for (const v of message.tradingSessions) {
      TradingSession.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExchangeTradingSession {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExchangeTradingSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tradingSessions.push(TradingSession.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExchangeTradingSession {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradingSessions: globalThis.Array.isArray(object?.tradingSessions)
        ? object.tradingSessions.map((e: any) => TradingSession.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ExchangeTradingSession): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.tradingSessions?.length) {
      obj.tradingSessions = message.tradingSessions.map((e) => TradingSession.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExchangeTradingSession>, I>>(base?: I): ExchangeTradingSession {
    return ExchangeTradingSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExchangeTradingSession>, I>>(object: I): ExchangeTradingSession {
    const message = createBaseExchangeTradingSession();
    message.exchange = object.exchange ?? 0;
    message.tradingSessions = object.tradingSessions?.map((e) => TradingSession.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
